import { render, staticRenderFns } from "./SystemCommunicationsHeader.vue?vue&type=template&id=431118fa&scoped=true"
import script from "./SystemCommunicationsHeader.vue?vue&type=script&lang=js"
export * from "./SystemCommunicationsHeader.vue?vue&type=script&lang=js"
import style0 from "./SystemCommunicationsHeader.vue?vue&type=style&index=0&id=431118fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431118fa",
  null
  
)

export default component.exports